import React from "react";
import { Control } from "react-redux-form";

interface Props {
  model: string;
  label: string;
  id: string;
  subLabel?: string;
  onCheckedChange?: (isToggled: boolean) => void;
  validators?: { [validatorName: string]: (val: string) => boolean };
}

export class CheckBox extends React.Component<Props> {
  public render() {
    return (
      <div className="rrf-check-box">
        <Control.checkbox
          id={this.props.id}
          model={this.props.model}
          onChange={e => this.props.onCheckedChange && this.props.onCheckedChange(e.target["checked"])}
          validators={this.props.validators}
        />
        <label htmlFor={this.props.id} className={this.props.subLabel ? "has-sub-label" : ""}>
          {this.props.label}
          {this.props.subLabel && <p className="sub-label">{this.props.subLabel}</p>}
        </label>
        { this.props.children }
      </div>
    );
  }
}
